// @flow

import qs from 'qs'
import { compose } from 'recompose'
import ReactGA from 'react-ga'

const stringify = data => ({
  credentials: 'include',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  body: qs.stringify(data)
})

const errorHandler = err => { throw err }

const jsonify = request => request.then(res => {
  try {
    return res.json()
  } catch (e) {
    errorHandler(e)
  }
})
const handleErrors = request => request.catch(errorHandler)
const enhanceRequest = compose(
  jsonify,
  handleErrors
)

const createRequestWithData = (method) => (url: string, data: Object = {}) => enhanceRequest(fetch(url, {
  method,
  ...stringify(data)
}))

const post = createRequestWithData('POST')
const deleteRq = createRequestWithData('DELETE')

export const postFile = (url, data) => enhanceRequest(fetch(url, {
  method: 'POST',
  contentType: false,
  processData: false,
  credentials: 'include',
  body: data,
}))

const get = (url) => enhanceRequest(fetch(url, { credentials: 'include' }))

const dumbPost = (action, options) => post(action, options)

export const fetchUser = () => get('/user.json')

export const logIn = dumbPost
export const forgotPassword = dumbPost
export const uploadFile = dumbPost

export const changePassword = dumbPost

export const addReport = dumbPost
export const addQuiz = dumbPost
export const addContact = dumbPost
export const addFaqQuestion = dumbPost

export const logOut = () => fetch('/logout', { credentials: 'include' })

export const fetchMenu = url => get(url)
export const fetchReset = url => get(url)

export const fetchFeatured = () => get('/featured.json')
export const fetchFaq = () => get('/faq.json')
export const fetchPoll = () => get('/survey.json')
export const fetchCounter = () => get('/counter.json')
export const fetchDonator = () => get('/donator/form/render.json')
export const submitDonator = (data) => post('/donator/form/submit.json', data)
export const searchTerm = term => get(`/search/${term}.json`)
export const fetchPage = (page, preview) => get(`${page}.json${preview ? `?preview=true` : ''}`)
export const fetchAgenda = (year, month, pathname) => get(`${pathname}/${year}/${month}.json`)
export const fetchThefts = (models, ref) => get(`/alerts/thefts.json?model=${models}&serialNb=${encodeURIComponent(ref)}`)

export const addBookmark = (item) => post(`/bookmarks.json`, item)
export const addStock = (item) => post(`/stock/update-quantity.json`, item)
export const removeBookmark = (item) => deleteRq(`/bookmarks.json`, item)
export const updateProfile = (url, item) => post(url, item)
export const fetchCharity = () => get(`/brand/charity.json`)

// CHALLENGE
export const fetchChallenge = () => get(`/challenge/quiz/self-ranking.json`)

// QUIZZ
export const fetchQuestion = (id) => get( id === 'current' ? `/challenge/quiz/question.json` : `/challenge/quiz/${id}/question.json`)

// GA
export const initGA = (username = 'no-name') => ReactGA.initialize('UA-166262585-1', {
  gaOptions: {
    userId: username,
  }
})



// WEBPACK FOOTER //
// ./src/services/ApiController.js